import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { webPushManager } from '../src/Components/Utils/webPush';

(window as any).webPushManager = webPushManager;

const initializeWebPush = async () => {
  try {
    if (webPushManager.isSupported()) {
      await webPushManager.registerServiceWorker();
      console.log('Web Push service worker registered successfully');
    }
  } catch (error) {
    console.error('Failed to initialize Web Push:', error);
  }
};

initializeWebPush();

const rootElement = document.getElementById('root');
if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

reportWebVitals();
